'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024$0024anon$002410 from "./presto.types$-Day-Of-Week-Utils$$anon$10.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DayOfWeekUtils$() {
  this.c59 = null;
  this.c5a = false;
  this.c57 = null;
  this.c58 = false;
}
export { $c_Lpresto_types$DayOfWeekUtils$ as $c_Lpresto_types$DayOfWeekUtils$ };
$p = $c_Lpresto_types$DayOfWeekUtils$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DayOfWeekUtils$;
/** @constructor */
function $h_Lpresto_types$DayOfWeekUtils$() {
}
export { $h_Lpresto_types$DayOfWeekUtils$ as $h_Lpresto_types$DayOfWeekUtils$ };
$h_Lpresto_types$DayOfWeekUtils$.prototype = $p;
$p.cHU = (function() {
  if ((!this.c5a)) {
    this.c59 = new $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024$0024anon$002410.$c_Lpresto_types$DayOfWeekUtils$$anon$10(this);
    this.c5a = true;
  }
  return this.c59;
});
$p.cHG = (function() {
  if ((!this.c58)) {
    this.c57 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljava_time_DayOfWeek$().cQT(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.c58 = true;
  }
  return this.c57;
});
$p.cCW = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().ag($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Ljava_time_DayOfWeek.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek()])));
});
var $d_Lpresto_types$DayOfWeekUtils$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DayOfWeekUtils$, "presto.types$DayOfWeekUtils$", ({
  Zo: 1
}));
export { $d_Lpresto_types$DayOfWeekUtils$ as $d_Lpresto_types$DayOfWeekUtils$ };
var $n_Lpresto_types$DayOfWeekUtils$;
function $m_Lpresto_types$DayOfWeekUtils$() {
  if ((!$n_Lpresto_types$DayOfWeekUtils$)) {
    $n_Lpresto_types$DayOfWeekUtils$ = new $c_Lpresto_types$DayOfWeekUtils$();
  }
  return $n_Lpresto_types$DayOfWeekUtils$;
}
export { $m_Lpresto_types$DayOfWeekUtils$ as $m_Lpresto_types$DayOfWeekUtils$ };
//# sourceMappingURL=presto.types$-Day-Of-Week-Utils$.js.map
